
import ogPagesMixins from '@/mixins/ogPagesMixins'

// Начальный лимит данных
const LIMIT = 10

// Настройки SEO полей head
const SEO = {
  TITLE: 'Популярные акции | Мегасреда',
  DESCRIPTION:
    'В этом разделе мы собрали софт, сервис и решения, обеспечивающие качественную работу специалистов и всей компании. Выбирайте то, что подойдёт именно вам. Ежедневно к платформе присоединяются новые компании, готовые предоставить лучшие цены. Действующие скидки и акции позволяют сэкономить до 70 % стоимости. Многие сервисы можно получить бесплатно в рамках тест-драйва. Акции отсортированы по популярности у пользователей Мегасреды.',
  H1: 'Популярные акции от компаний поставщиков продуктов и сервисов, обеспечивающих качественную работу специалистов и компании в целом.',
  IMAGE: {
    url: 'https://megasreda.ru/img/products/offers_ogg.jpg',
    urlVk: 'https://megasreda.ru/img/products/offers_ogg-vk.jpg',
    urlTw: 'https://megasreda.ru/img/products/offers_ogg.jpg',
    type: 'image/jpeg',
    width: 1200,
    height: 630,
  },
}
const emptyFetch = async ($axios, offset) => {
  const { products, countAllPublishedProducts } = await $axios.$get(
    'advertisements/products',
    {
      params: {
        grid: false,
        limit: LIMIT,
        offset,
      },
    }
  )
  return {
    products,
    productsCount: countAllPublishedProducts,
  }
}
const fullFetch = async ($axios, offset) => {
  const { products, countAllPublishedProducts } = await $axios.$get(
    'advertisements/subscriptions',
    {
      params: {
        type: 'offers',
        grid: false,
        limit: LIMIT,
        offset,
      },
    }
  )
  return {
    products,
    productsCount: countAllPublishedProducts,
  }
}

export default {
  mixins: [ogPagesMixins],
  scrollToTop: true,

  async asyncData({ $axios, $auth }) {
    if (!$auth.loggedIn) {
      return await emptyFetch($axios, 0)
    } else {
      const { products, productsCount } = await fullFetch($axios)

      if (!products?.length) {
        return await emptyFetch($axios, 0)
      } else {
        return {
          products,
          productsCount,
        }
      }
    }
  },
  data() {
    return {
      products: [],
      productsCount: 0,
      page: this.$route.query?.page ? this.$route.query.page : 1,
    }
  },
  computed: {
    seoTitle() {
      return SEO.TITLE
    },
    seoDescription() {
      return SEO.DESCRIPTION
    },
    seoH1() {
      return SEO.H1
    },
    seoImage() {
      return SEO.IMAGE
    },
    pageCount() {
      return Math.ceil(this.productsCount / LIMIT)
    },
    productsOffset() {
      return (this.page - 1) * LIMIT
    },
  },
  watch: {
    $route() {
      if (!this.$route.query?.page) {
        this.page = 1
        this.products = []
        this.$router.push({
          query: {},
        })
        this.fetchProducts()
      }
    },
  },

  methods: {
    whyVisible(product) {
      if (this.$auth.loggedIn) {
        const subscribersStreams = product?.streams.filter((item) => {
          return this.$auth.user.subscriptions.streams.some(
            (item2) => item2.stream === item._id
          )
        })
        const subscribeAuthor = this.$auth.user.subscriptions.authors.some(
          (item) => item.author === product?.author._id
        )

        if (subscribersStreams?.length && !subscribeAuthor) {
          return subscribersStreams[0]
        }
      } else {
        return null
      }
    },

    hexToRgbA(hex) {
      let c
      if (/^#([A-Fa-f0-9]{3}){1,2}$/.test(hex)) {
        c = hex.substring(1).split('')
        if (c.length === 3) {
          c = [c[0], c[0], c[1], c[1], c[2], c[2]]
        }
        c = '0x' + c.join('')
        return (
          'rgba(' +
          [(c >> 16) & 255, (c >> 8) & 255, c & 255].join(',') +
          ',0.1)'
        )
      }
      return hex
    },
    paginateClick(page) {
      this.products = []
      if (page === 1) {
        this.$router.push({
          query: {},
        })
      } else {
        this.$router.push({
          query: {
            ...this.$route.query,
            page: this.page,
          },
        })
        this.fetchProducts()
      }
      this.$scrollTo('body')
    },
    updateOffer() {
      this.products = []
      this.fetchProducts()
    },
    async fetchProducts() {
      if (!this.$auth.loggedIn) {
        const { products, productsCount } = await emptyFetch(
          this.$axios,
          this.productsOffset
        )

        this.productsCount = productsCount

        this.products = this.products?.length
          ? this.products.concat(products)
          : products
      } else {
        const { products, productsCount } = await fullFetch(
          this.$axios,
          this.productsOffset
        )

        if (!products?.length) {
          const { products, productsCount } = await emptyFetch(
            this.$axios,
            this.productsOffset
          )

          this.productsCount = productsCount
          this.products = this.products?.length
            ? this.products.concat(products)
            : products
        } else {
          this.productsCount = productsCount
          this.products = this.products?.length
            ? this.products.concat(products)
            : products
        }
      }
    },
    loadMore() {
      this.page++
      this.$router.push({
        query: {
          ...this.$route.query,
          page: this.page,
        },
      })
      this.fetchProducts()
    },
  },
}
